import { Component, Input, OnInit } from '@angular/core';
import {jsPDF} from 'jspdf';
import { environment } from 'src/environments/environment';
import html2canvas from 'html2canvas';
@Component({
  selector: 'calsoft-certificate-download',
  templateUrl: './certificate-download.component.html',
  styleUrls: ['./certificate-download.component.scss']
})
export class CertificateDownloadComponent implements OnInit {
  @Input() data:any;
  @Input() order:any;

  ngOnInit() {
    this.certificateType = this.data['certificateType'];
  }
  certificateType: any;
  h2c: any = html2canvas;
  public serverPath = environment.serverAPI2+"/api/core/download?fileName=logo/logo.png";

  generate(){
    let DATA: any = document.getElementById('htmlData');
    DATA.style.display = 'block';
    this.h2c(DATA, {
      allowTaint: true,
      useCORS: true
   }).then((canvas) => {
    let fileWidth = 208;
    let fileHeight = (canvas.height * fileWidth) / canvas.width;
    const FILEURI = canvas.toDataURL('image/png');
    let PDF = new jsPDF('p', 'mm', 'a4');
    let position = 0;
    PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
  
    let name='Certificate-'+this.order.extOrderId+'.pdf';
    PDF.save(name);
    DATA.style.display = 'none';
   });
  ;
  }
}
